class ProductPageModal extends HTMLElement {
    constructor() {
        super();
        this.closeButton = this.querySelectorAll('.modal-close')
        this.closeButton.forEach(button => button.addEventListener(
            'click',
            this.close.bind(this)
        ))

        this.customFields = this.dataset.customFields ? this.dataset.customFields.split(', ') : null
        this.openButtons = Array.from(document.querySelectorAll('.shipping-button'))
        this.openButtons.forEach(button => button.addEventListener("click", this.open.bind(this, { type: 'shipping-info' })))
        this.openButtonsPolicy = Array.from(document.querySelectorAll('.consumer-policy-button'))
        this.openButtonsPolicy.forEach(button => button.addEventListener("click", this.open.bind(this, { type: 'consumer-policy-info' })))
        this.submitButtons = document.querySelectorAll(".product-form__submit");
        this.cartDrawer = document.querySelector('cart-drawer');
        this.genericError = "An unexpected error occured. Please try again.";


        this.submitButtons.forEach((button) => {
            button.addEventListener("click", (e) => {
                const productType = button.dataset.productType ? button.dataset.productType : null
                const form = button.closest("form");
                const urlParams = new URLSearchParams(window.location.search);
                let isSubscription = urlParams.get("selling_plan");
                if(!isSubscription) {
                    const subscriptionInput = form.querySelector('[data-selling-plan-input]');
                    if(subscriptionInput) {
                        isSubscription = subscriptionInput.value;
                    }
                }
                const subConsent = document.getElementById('subscription_consent_given')
                const errorTexts = Array.from(document.querySelectorAll('.product-form-error .main-error'))
                errorTexts.forEach(el => {
                    el.classList.add('hide')
                    el.innerText = '* Please complete all fields'
                })

                if (productType === 'demographic_info') {
                    e.preventDefault();
                    e.stopPropagation();
                    this.clearInputs()
                    this.open({ type: 'demographic-info' })

                    const modalAddToCart = this.querySelector('#modal-add-to-cart')

                    if (modalAddToCart) {
                        modalAddToCart.addEventListener("click", (e) => {
                            const formInputs = document.getElementById('demographic-modal-form')
                            const modalForm = new FormData(formInputs)

                            const isValid = this.validateInputs(formInputs, true)

                            if (isValid) {

                                // add inputs to product form
                                for (let [name, value] of modalForm.entries()) {

                                    const hiddenInput = document.createElement('input');
                                    hiddenInput.type = 'hidden';
                                    hiddenInput.name = name;
                                    hiddenInput.value = value;

                                    form.appendChild(hiddenInput);
                                }
                                // add consent date 
                                const consentDateInput = document.createElement('input')
                                consentDateInput.type = 'hidden'
                                consentDateInput.name = 'properties[consent_date]'
                                consentDateInput.value = `${new Date()}`;
                                form.appendChild(consentDateInput)

                                this.addToCart(form, true)
                            }
                        })
                    }

                    return
                }

                if (productType === 'testing_kit') {
                    e.preventDefault();
                    e.stopPropagation();
                    this.clearInputs();
                    this.open({ type: 'testing-kit' })

                    const nextViewButton = this.querySelector('#modal-next-view');
                    const backButton = this.querySelector('#modal-prev-view')
                    const view1 = this.querySelector('#testing-kit')
                    const view2 = this.querySelector('#testing-kit-view-2')

                    if (view1.classList.contains('hidden')) {
                        view1.classList.remove('hidden')
                    }

                    if (!view2.classList.contains('hidden')) {
                        view2.classList.add('hidden')
                    }


                    if (nextViewButton) {
                        nextViewButton.addEventListener("click", () => {

                            // validate form 1 here
                            const view1form = document.getElementById('participant-info-modal-form')
                            const isValid = this.validateInputs(view1form, true)

                            if (isValid) {
                                view1.classList.add('hidden')
                                view2.classList.remove('hidden')
                            }

                        })
                    }


                    const modalAddToCart = this.querySelector('#modal-add-to-cart')

                    if (modalAddToCart) {
                        modalAddToCart.addEventListener("click", (e) => {
                            const shippingFormInputs = document.getElementById('shipping-modal-form')


                            const isValid = this.validateInputs(shippingFormInputs, true, true)

                            if (isValid) {
                                const participantInfo = document.getElementById('participant-info-modal-form')
                                const participantEntries = new FormData(participantInfo)
                                const shippingInfoEntries = new FormData(shippingFormInputs)

                                // add inputs to participant info form
                                for (let [name, value] of participantEntries.entries()) {

                                    const hiddenInput = document.createElement('input');
                                    hiddenInput.type = 'hidden';
                                    hiddenInput.name = name;
                                    hiddenInput.value = value;

                                    form.appendChild(hiddenInput);
                                }
                                for (let [name, value] of shippingInfoEntries.entries()) {

                                    const hiddenInput = document.createElement('input');
                                    hiddenInput.type = 'hidden';
                                    hiddenInput.name = name;
                                    hiddenInput.value = value;

                                    form.appendChild(hiddenInput);
                                }
                                // add consent date 
                                const consentDateInput = document.createElement('input')
                                consentDateInput.type = 'hidden'
                                consentDateInput.name = 'properties[consent_date]'
                                consentDateInput.value = `${new Date()}`;
                                form.appendChild(consentDateInput)

                                this.addToCart(form, true)
                            }
                        })
                    }

                    if (backButton) {
                        backButton.addEventListener("click", () => {

                            view2.classList.add('hidden')
                            view1.classList.remove('hidden')
                        })
                    }

                    return
                }

                // custom fields check
                if (this.customFields) {
                    e.preventDefault();
                    e.stopPropagation
                    const consentDateElement = document.getElementById("consent_date");
                    if (consentDateElement) consentDateElement.value = new Date();

                    const isValid = this.validateInputs(form)

                    if (isSubscription) {
                        if(isValid)this.handleSubscription(subConsent, form)
                    } else {
                        if (isValid) this.addToCart(form)
                    }

                } else {
                    // subscription check 
                    if (isSubscription) {
                        e.preventDefault();
                        e.stopPropagation();
                        this.handleSubscription(subConsent, form)
    
                    }
                }


            });
        });
    }

    open({ type }) {
        if (type === 'shipping-info') {
            this.querySelector("#shipping-info").classList.remove("hidden")
        }

        if (type === 'consumer-policy-info') {
            this.querySelector("#consumer-policy-info").classList.remove("hidden")
        }

        if (type === 'subscription-confirmation') {
            this.querySelector("#subscription-confirmation").classList.remove("hidden")
        }

        if (type === 'testing-kit') {
            this.querySelector('#testing-kit').classList.remove("hidden")
            this.getQueryParams()
        }

        if (type === 'demographic-info') {
            this.querySelector('#demographic-info').classList.remove("hidden")
            this.getQueryParams()
        }
        this.classList.remove('hidden')
        document.body.classList.add('overflow-hidden');
    }


    close() {
        document.body.classList.remove('overflow-hidden');
        this.classList.add('hidden')

        const modalContent = this.querySelectorAll('.modal-content')
        modalContent.forEach(content => {
            content.classList.add('hidden')
        })
    }

    // Replace a button with a fresh clone to strip any previously-attached listeners
    // (the main add-to-cart flow re-binds these on every submit-button click). Returns
    // the new node so callers attach only their own handlers.
    resetButton(selector) {
        const btn = this.querySelector(selector);
        if (!btn) return null;
        const clone = btn.cloneNode(true);
        btn.replaceWith(clone);
        return clone;
    }

    // Open the modal purely to COLLECT consent/demographic line-item properties for an
    // external consumer (e.g. the Rebuy bundle add). Reuses the same modal views and
    // validation as the main add-to-cart flow, but instead of submitting the product form
    // it resolves with a plain { key: value } properties object (keys unwrapped from
    // `properties[...]`), plus consent_date. Resolves null if the customer closes the modal.
    collectProperties(productType) {
        return new Promise((resolve) => {
            const toProps = (...formDatas) => {
                const props = {};
                formDatas.forEach((fd) => {
                    for (const [name, value] of fd.entries()) {
                        const match = name.match(/^properties\[(.+)\]$/);
                        props[match ? match[1] : name] = value;
                    }
                });
                props.consent_date = `${new Date()}`;
                return props;
            };

            // Resolve null when the customer dismisses the modal without completing it.
            const closeButtons = this.querySelectorAll('.modal-close');
            const onClose = () => {
                closeButtons.forEach((b) => b.removeEventListener('click', onClose));
                resolve(null);
            };
            closeButtons.forEach((b) => b.addEventListener('click', onClose));

            if (productType === 'demographic_info') {
                this.clearInputs();
                this.open({ type: 'demographic-info' });
                const addBtn = this.resetButton('#modal-add-to-cart');
                if (!addBtn) { resolve(null); return; }
                addBtn.addEventListener('click', () => {
                    const formInputs = document.getElementById('demographic-modal-form');
                    if (!this.validateInputs(formInputs, true)) return;
                    closeButtons.forEach((b) => b.removeEventListener('click', onClose));
                    const props = toProps(new FormData(formInputs));
                    this.close();
                    resolve(props);
                });
                return;
            }

            if (productType === 'testing_kit') {
                this.clearInputs();
                this.open({ type: 'testing-kit' });

                const view1 = this.querySelector('#testing-kit');
                const view2 = this.querySelector('#testing-kit-view-2');
                if (view1) view1.classList.remove('hidden');
                if (view2) view2.classList.add('hidden');

                const nextBtn = this.resetButton('#modal-next-view');
                if (nextBtn) {
                    nextBtn.addEventListener('click', () => {
                        const v1 = document.getElementById('participant-info-modal-form');
                        if (this.validateInputs(v1, true)) {
                            view1.classList.add('hidden');
                            view2.classList.remove('hidden');
                        }
                    });
                }

                const backBtn = this.resetButton('#modal-prev-view');
                if (backBtn) {
                    backBtn.addEventListener('click', () => {
                        view2.classList.add('hidden');
                        view1.classList.remove('hidden');
                    });
                }

                const addBtn = this.resetButton('#modal-add-to-cart');
                if (!addBtn) { resolve(null); return; }
                addBtn.addEventListener('click', () => {
                    const shipping = document.getElementById('shipping-modal-form');
                    if (!this.validateInputs(shipping, true, true)) return;
                    const participant = document.getElementById('participant-info-modal-form');
                    closeButtons.forEach((b) => b.removeEventListener('click', onClose));
                    const props = toProps(new FormData(participant), new FormData(shipping));
                    this.close();
                    resolve(props);
                });
                return;
            }

            // Unknown / non-gated type — nothing to collect.
            closeButtons.forEach((b) => b.removeEventListener('click', onClose));
            resolve(null);
        });
    }

    async addToCart(form, isModal = false) {
        // Re-entry guard: the modal add-to-cart buttons (testing_kit / demographic_info) can fire
        // this more than once — rapid double-clicks, and listeners stacked by repeated submit-button
        // clicks — sending one /cart/add POST each (qty multiplies). The flag is set synchronously
        // before the await, so any concurrent call bails before posting.
        if (this._adding) return;
        this._adding = true;
        const formData = new FormData(form)
        try {
            const res = await fetch(`${routes.cart_add_url}?sections=cart-drawer,cart-icon-bubble`, {
                method: 'POST',
                headers: {
                    Accept: "application/javascript",
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: formData
            })
            if (!res.ok) {
                const data = await res.json();
                this.renderGeneralError(data.message ?? this.genericError);
                if (isModal) {
                    this.close()
                }
                return;
            }

            const data = await res.json();

            this.updateCart(data)
        } catch (error) {
            console.error(error);
            this.renderGeneralError(this.genericError);
        } finally {
            this._adding = false;
        }
    }

    updateCart(data) {
        this.cartDrawer.renderContents(data);

        if (this.cartDrawer.classList.contains("is-empty")) {
            this.cartDrawer.classList.remove("is-empty")
        }

        this.close()
    }

    getQueryParams() {
        let urlParams = window.location.href.split('?');
        if (urlParams.length > 1) {
          let params = urlParams[1].split('&')
          for (let i = 0; i < params.length; i++) {
            let paramsKeyValue = params[i].split('=');
            if (paramsKeyValue.length > 1) {
              if (paramsKeyValue[0] === 'precision_id') {
                let id_field = document.getElementById('precision_id');
                if (id_field) {
                  id_field.value = decodeURIComponent(paramsKeyValue[1]);
                }
              }
              else if (paramsKeyValue[0] === 'email') {
                let email_field = document.getElementById('email');
                if (email_field) {
                  email_field.value = decodeURIComponent(paramsKeyValue[1]);
                }
              }
            }
          }
        }
      }

    validateInputs(form, isModal = false, isViewTwo = false) {
        this.clearErrors()
        const stringFormat = /^[A-Za-z\s-]+$/;
        const email_format = /^[\w.+-]+@([\w-]+\.)+[\w-]{2,4}$/;
        const precision_format1 = /^[A-Za-z]{2}-?\d{5}-?\d{5}$/;
        const precision_format2 = /^NG-?[A-HJ-NP-XZa-hj-np-xz1-9]{9}[A1-9]$/;
        const phoneFormat = /^\+?[0-9]{0,3}[-.\s]?\(?[0-9]{3}\)?[-.\s]?[0-9]{3}[-.\s]?[0-9]{4,6}$/;
        const cityFormat = /^[A-Za-z\s-]+$/;
        const zipCodeFormat = /^\d{5}(?:[-\s]\d{4})?$/
        let noErrors = true
        let allFieldsFilled = true
        const requiredFields = Array.from(form.querySelectorAll('.required'))
        const modalId = isViewTwo ? 'modal-form-error-2' : 'modal-form-error'
        const productFormErrorText = isModal ? document.getElementById(modalId) : document.getElementById('product-form-error')
        productFormErrorText.innerText = '* Please fill out all fields!'

        requiredFields.forEach(formField => {
            if (!formField.value || formField.value.trim() === '') {
                allFieldsFilled = false
            }

            if (formField.type === 'checkbox' && !formField.checked) {
                allFieldsFilled = false
                productFormErrorText.innerText = "* Please Accept our 10X Medial Release"
            }

            if (formField.id === 'first_name') {
                if (!formField.value.match(stringFormat)) {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#first_name_error_message').classList.remove('hide')
                }
            }
            if (formField.id === 'last_name') {
                if (!formField.value.match(stringFormat)) {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#last_name_error_message').classList.remove('hide')
                }
            }

            if (formField.id === 'phone') {
                if (!formField.value.match(phoneFormat)) {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#phone_error_message').classList.remove('hide')
                }
            }

            if (formField.id === 'email') {
                if (!formField.value.match(email_format)) {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#email_error_message').classList.remove('hide')
                }
            }

            if (formField.id === 'gender') {
                if (!formField.value.match(stringFormat)) {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#gender_error').classList.remove('hide')
                }
            }

            if (formField.id === 'address') {
                if (formField.value === '') {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#address_error').classList.remove('hide')
                }
            }

            if (formField.id === 'city') {
                if (!formField.value.match(cityFormat)) {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#city_error').classList.remove('hide')
                }
            }

            if (formField.id === 'zip-code') {
                if (!formField.value.match(zipCodeFormat)) {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#zip_error').classList.remove('hide')
                }
            }
            if (formField.id === 'state') {
                if (!formField.value.match(stringFormat)) {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#state_error').classList.remove('hide')
                }
            }

            if (formField.id === 'country') {
                if (!formField.value.match(stringFormat)) {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#country_error').classList.remove('hide')
                }
            }

            if (formField.id === 'consent_first_name' || formField.id === 'consent_last_name') {
                if (!formField.value.match(stringFormat)) {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#consent_error').classList.remove('hide')
                }
            }

            if (formField.id === 'precision_id') {
                if (!formField.value.match(precision_format1) && !formField.value.match(precision_format2)) {
                    noErrors = false
                    formField.classList.add('error_msg')
                    document.querySelector('#precision_id_error').classList.remove('hide')
                } else {
                    formField.value = formField.value.replace(/-/g, '');
                  }
            }

            if (formField.id === 'month') {
                //Calculate Age 
                const isMinor = this.determineAge()

                if (formField.dataset.minorStatus === 'disallow' && isMinor) {
                    noErrors = false
                    document.querySelector('#dob_error').classList.remove('hide')
                }

                if (formField.dataset.minorStatus === 'guardian-required' && isMinor) {
                    const guardianEmailInput = this.querySelector('#guardian_email')
                    const guardianEmailError = this.querySelector('#gaurdian_error')
                    if (guardianEmailInput.value) {
                        if (!guardianEmailInput.value.match(email_format)) {
                            noErrors = false
                            guardianEmailError.innerText = '* Please enter a valid email address'
                        } else if (guardianEmailInput.value === document.querySelector('#email').value) {
                            noErrors = false
                            guardianEmailError.innerText = "* Gaurdian Email cannot be the same as Participant's email"
                        }
                    } else {
                        noErrors = false
                        guardianEmailError.innerText = "* Please enter your parent or guardian email address so we can have them provide consent on your behalf."
                        document.querySelector('#gaurdian-email-container').classList.remove('hide')
                    }

                }

            }
        })

        if (!allFieldsFilled) {
            productFormErrorText.classList.remove('hide')
            return false
        }

        if (!noErrors) {
            return false
        }
        return true
    }

    clearErrors() {
        const customInputs = Array.from(document.getElementsByClassName('custom-input'))
        customInputs.forEach(el => el.classList.remove('error_msg'))

        const errorMessages = Array.from(document.getElementsByClassName('product-form-error'))
        errorMessages.forEach(el => el.classList.add('hide'))
    }

    clearInputs() {
        const customInputs = Array.from(document.getElementsByClassName('custom-input'))
        customInputs.forEach(el => {
            if (el.tagName === 'SELECT') {
                el.selectedIndex = 0;
            } else {
                el.value = null;
            }
        })

        const checkbox = this.querySelector("#consent_given")
        if (checkbox) {
            checkbox.checked = false
        }
    }

    renderGeneralError(errorMessage) {
        const productError = document.getElementById("product-form-error");
        if (productError) {
            productError.classList.remove('hide');
            productError.innerText = errorMessage;
        }
    }

    determineAge() {
        const monthValue = this.querySelector('#month').value
        const dayValue = this.querySelector('#day').value
        const yearValue = this.querySelector('#year').value

        const birthdayString = `${monthValue} ${dayValue} ${yearValue}`
        const birthdayDate = new Date(birthdayString)
        const today = new Date()

        let age = today.getFullYear() - birthdayDate.getFullYear()
        const monthDiff = today.getMonth() - birthdayDate.getMonth()
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthdayDate.getDate())) {
            age--;
        }
        return age < 18

    }

    // Surface a cart error inside the subscription-confirmation modal. The precision PDP has no
    // #product-form-error element (that lives only in buy-buttons.liquid), so renderGeneralError
    // silently no-ops here — this targets the modal's own error <p> instead.
    renderSubscriptionError (errorMessage) {
        const el = this.querySelector('#subscription-form-error');
        if (!el) return;
        el.classList.toggle('hide', !errorMessage);
        el.innerText = errorMessage || '';
    }

    // Fill the modal's billing-terms line with the frequency of the plan the customer picked
    // ("Ships every 2 months" → "every 2 months"). Read at open time because the plan can change
    // client-side after the modal markup is rendered. Falls back to the default wording already in
    // the DOM when no plan label is found (e.g. a single-plan PDP).
    setSubscriptionFrequency (form) {
        const target = this.querySelector('[data-subscription-frequency]');
        if (!target) return;

        // Precision templates expose a hidden input; the default template renders the Appstle
        // widget, where the picked plan is a checked radio named selling_plan.
        const planId = form?.querySelector('[data-selling-plan-input]')?.value
            || document.querySelector('input[name="selling_plan"]:checked')?.value;

        // Label sources, in order: the precision frequency <select>, then the plan's own <label>
        // (Appstle sets label[for] to the plan id, with the price in a nested <div> we drop).
        const select = document.querySelector('[data-frequency-select]');
        let label = '';

        if (select) {
            const option = planId
                ? [...select.options].find((o) => o.value === String(planId))
                : select.selectedOptions[0];
            label = option?.textContent?.trim() ?? '';
        }

        if (!label && planId) {
            const planLabel = document.querySelector(`label[for="${CSS.escape(String(planId))}"]`);
            label = planLabel
                ? [...planLabel.childNodes]
                    .filter((n) => n.nodeType === Node.TEXT_NODE)
                    .map((n) => n.textContent)
                    .join(' ')
                    .trim()
                : '';
        }

        // Plan names are merchant-authored ("Ships every 2 months", "Delivery every 30 days").
        // Keep only the "every …" part so the sentence reads naturally.
        const match = label.match(/every\s+.+/i);
        if (match) target.textContent = match[0].toLowerCase();
    }

    handleSubscription (subConsent, form) {
        this.open({ type: 'subscription-confirmation' })
        this.setSubscriptionFrequency(form)
        this.renderSubscriptionError('')

        // Strip listeners stacked by a previous submit click. The confirm button and the
        // consent checkbox persist in the DOM (the PDP no longer re-renders on variant change),
        // so re-binding without a reset would fire one extra /cart/add POST per earlier add
        // (1st add → qty 1, 2nd add → qty 3, …). resetButton() clones each node to drop its
        // listeners and returns the fresh node — same pattern as collectProperties().
        const addToCartBtn = this.resetButton('#subcription-add-to-cart')
        const consent = this.resetButton('#subscription_consent_given')
        if (!addToCartBtn || !consent) return

        // Reflect the current consent state on the fresh button (clone resets to unchecked).
        addToCartBtn.disabled = !consent.checked

        consent.addEventListener('change', function () {
            addToCartBtn.disabled = !this.checked;
        });

        addToCartBtn.addEventListener("click", async () => {
            // Prevent double-submit: while the /cart/add request is in flight the button must be
            // disabled, otherwise rapid clicks fire one POST each and the line quantity multiplies
            // (click 3× → qty 3). A disabled button dispatches no further clicks. Re-enabled in
            // `finally` based on consent state — kept disabled after a successful add (consent is
            // cleared), re-enabled on error so the customer can retry.
            if (addToCartBtn.disabled) return;
            addToCartBtn.disabled = true;
            addToCartBtn.classList.add('loading');

            this.renderSubscriptionError('')
            const formData = new FormData(form)
            try {
                const res = await fetch(`${routes.cart_add_url}?sections=cart-drawer,cart-icon-bubble`, {
                    method: 'POST',
                    headers: {
                        Accept: "application/javascript",
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: formData
                })

                if (!res.ok) {
                    const data = await res.json();
                    // Keep the modal open and show the same detail string the one-time
                    // <product-form> flow surfaces (response.description, e.g. the quantity-rule
                    // message). renderGeneralError targets #product-form-error which doesn't exist
                    // on this PDP, so the error was previously invisible for subscriptions.
                    this.renderSubscriptionError(data.description ?? data.message ?? this.genericError);
                    return;
                }

                const data = await res.json();

                this.updateCart(data)
                consent.checked = false
            } catch (error) {
                console.error(error);
                this.renderSubscriptionError(this.genericError);
            } finally {
                addToCartBtn.classList.remove('loading');
                // Mirror the consent gate: disabled after success (consent cleared above), re-enabled
                // for retry on error (consent still checked).
                addToCartBtn.disabled = !consent.checked;
            }
        })
    }
}

customElements.define('product-page-modal', ProductPageModal);
